import RegularText from '@/components/RegularText';
import { PATH } from '@/constants/path';
import { checkDirtyField } from '@/helpers/compare';
import { widgetTextDefaultDetailSelector } from '@/redux/slice/widget.slice';
import { widgetTextDetailSelector } from '@/redux/slice/widgetText.slice';
import { IShopifyAppMetafieldPayload } from '@/types/components/metafield';
import { Box, Icon, InlineStack } from '@shopify/polaris';
import { AlertCircleIcon } from '@shopify/polaris-icons';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

interface Props {
  shopMetafieldsData?: IShopifyAppMetafieldPayload;
  translationWidgetOptions: {
    label: string;
    value: string;
  }[];
  selectedLanguage?: string;
}

export const WidgetAppearanceError = ({ shopMetafieldsData, translationWidgetOptions, selectedLanguage }: Props) => {
  const widgetTextDefaultDetail = useSelector(widgetTextDefaultDetailSelector);
  const widgetTextDetail = useSelector(widgetTextDetailSelector);

  const location = useLocation();

  const fullCodeTranslation = useMemo(
    () => translationWidgetOptions.map((option) => option.value.split('_')[0]),
    [translationWidgetOptions],
  );

  if (
    checkDirtyField(widgetTextDefaultDetail, widgetTextDetail).isDirty &&
    location.pathname === PATH.WIDGET.pathname &&
    widgetTextDefaultDetail.code === widgetTextDetail.code &&
    (fullCodeTranslation.length !== new Set(fullCodeTranslation).size
      ? widgetTextDefaultDetail.defaultLanguage === widgetTextDetail.defaultLanguage
      : true)
  ) {
    return (
      <Box paddingInline={'300'} paddingBlock={'200'} paddingBlockEnd={'0'}>
        <InlineStack gap={'100'}>
          <Box color="text-critical">
            <Icon source={AlertCircleIcon} />
          </Box>
          <RegularText tone="critical" fontWeight="medium">
            Please save the content to show on widget
          </RegularText>
        </InlineStack>
      </Box>
    );
  }
};
